import React from "react"
import {FieldTableCellProps, getTableCellStyle} from "../../../render/table/table-cell";
import {FieldViewSize} from "../../../const";
import {LifecycleAction} from "../../../../gd/const/lifecycle";

// this is very default table cell
// unlike other proto render componetns this really does the job
// not sure why yet but I think it some cases we want to re-write the entire cell compoenent
// so I give it a layer - if need custom table cell see this class as example

export default function FieldProto_TableCell(props:FieldTableCellProps):React.ReactElement {


    const onChange = (value:any) => {

        // if field has tableCellOnValueChange - use it !!!
        if (props.field.fieldParams.tableCellOnValueChange) {
            props.field.fieldParams.tableCellOnValueChange(props.listItem, value, props.manager)
            return
        }

        // Otherwise default = custom field



        // this is for custom fields (!!!)
        // system fields should have their own

        props.listItem.task.setCustomFieldValue(props.field.fieldId, value)
        props.listItem.task.save()

        // need decide how to approach this ...
        // i guess some custom fields can do it (based ion type)
        // some not - it' about aggregation
        props.listItem._updateLastUpdateTime() // otherwise it wont re-render

        props.manager.update([LifecycleAction.PROCESS_DATA, LifecycleAction.RENDER])

    }

    return (
        <div className="cell-flex p-h-0" style={getTableCellStyle(props)}>

            <props.field.renderComponents.editable size={FieldViewSize.SMALL}
                                                   className="w-100-percent h-100-percent"
                                                   disabled={props.manager.isReadOnly}
                                                   field={props.field}
                                                   model={props.listItem.item}
                                                   onChange={props.onChange ? props.onChange : onChange}
                                                   onBlur={props.onBlur}
                                                   onFocus={props.onFocus}
            />

        </div>

    )

}
